import PostHero from './hero';
import PostShort from './short';
import PostVideo from './video';
import PostDefault from './default';
import ListArticle from './list';
import GiftGuide from './gift';
import EventVideo from './event_video';
import PhotoEssay from './photo_essay';

export {
  PostHero,
  PostShort,
  PostVideo,
  PostDefault,
  ListArticle,
  GiftGuide,
  EventVideo,
  PhotoEssay
};
